import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { cn } from '@discover-lib/utils';
import { useAnalytics } from '@/components/analytics/hooks/useAnalytics';

export type CommandItemProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Item>;

const CommandItem = forwardRef<ElementRef<typeof CommandPrimitive.Item>, CommandItemProps>(
  ({ className, ...props }, ref) => {
    const { track } = useAnalytics();
    const trackAndSelect = (value: string) => {
      track('button_clicked', {
        button_type: 'selection',
        button_copy: value,
      });

      props.onSelect?.(value);
    };

    return (
      <CommandPrimitive.Item
        ref={ref}
        className={cn(
          'relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-base outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50',
          className
        )}
        {...props}
        onSelect={trackAndSelect}
      />
    );
  }
);

CommandItem.displayName = CommandPrimitive.Item.displayName;

export default CommandItem;
